<template>
  <input
    ref="inputRef"
    v-bind="$attrs"
    :placeholder="placeholder"
    :value="modelValue"
    class="w-full text-lg placeholder-current border-1 md:border-2 rounded-md appearance-none rtl:text-right _base-input disabled:cursor-not-allowed focus:outline-none focus:border-primary-6 border-neutral-9"
    @input="$emit('update:modelValue', $event.target.value)"
  >
</template>

<script>
import { ref } from "vue";
export default {
  name: "BaseInput",
  props: {
    placeholder: {
      type: String,
      default: "",
      required: false,
    },
    modelValue: {
      type: [String, Number],
      default: "",
    }
  },
  emits: ["update:modelValue"],
  setup() {
    const inputRef = ref(null);

    function focusInput() {
      inputRef.value.focus();
    }
    return {
      inputRef,
      focusInput
    }
  }
};
</script>

<style scoped>
  /* Chrome, Safari, Edge, Opera */
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  input[type=number] {
    -moz-appearance: textfield;
  }
  @layer utilities {
    ._base-input::placeholder {
      font-weight: normal;
    }
  }
</style>
